const LANG_KEY = "lefy_lang"; // no expiry

export const LANG_ID = "id";
export const LANG_ZH = "zh";

export function getLang() {
  return localStorage.getItem(LANG_KEY) || LANG_ZH; // default Chinese
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang);
}

export function isZh() {
  return getLang() === LANG_ZH;
}
